import React, { useState, useEffect, useCallback } from 'react';

import { Card } from '@mui/material';

import { Upload } from './Upload';
import useResponsive from '../../../hooks/useResponsive';
import DocumentsUploadDialog from './DocumentsUploadDialog';

// --------------------------------------------------------

const ALLOWED_FILE_TYPES =
  '.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.jpeg,.jpg,.png,.adoc,.edoc,.bdoc,.asice,.txt';
const MAX_FILE_SIZE = 50 * 1024 * 1024; // 50MB

type DocumentsUploadWidgetProps = {
  folderId?: number;
};

const DocumentsUploadWidget: React.FC<DocumentsUploadWidgetProps> = ({ folderId }) => {
  const [files, setFiles] = useState<File[]>([]);
  const [open, setOpen] = useState(false);
  const isMobile = useResponsive('only', 'xs');

  const handleDropMultiFile = useCallback((acceptedFiles: File[]) => {
    setFiles((prevFiles) => [...prevFiles, ...acceptedFiles]);
  }, []);

  useEffect(() => {
    if (files.length > 0 && !open) {
      setOpen(true);
    }
  }, [files]);

  return (
    <Card
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        cursor: 'pointer',
        position: 'relative',
        width: isMobile ? '100%' : '360px',
        px: isMobile ? 1.5 : 3,
        py: isMobile ? 1 : 2,
      }}
    >
      <Upload
        multiple
        onDrop={handleDropMultiFile}
        isWidget
        accept={ALLOWED_FILE_TYPES}
        maxSize={MAX_FILE_SIZE}
      />

      <DocumentsUploadDialog
        ALLOWED_FILE_TYPES={ALLOWED_FILE_TYPES}
        MAX_FILE_SIZE={MAX_FILE_SIZE}
        folderId={folderId}
        files={files}
        setFiles={setFiles}
        open={open}
        setOpen={setOpen}
      />
    </Card>
  );
};

export default DocumentsUploadWidget;
